module.exports = __webpack_public_path__ + "img/qr_instagram.355daa42.svg";